"use client";

import { useEffect, useState } from "react";

import CheckoutReviewVendorOrderSection from "@/app/checkout/(squeeze)/review/checkoutReviewVendorOrderSection";
import StandardDeliveryVendor from "@/app/checkout/(squeeze)/review/twoDayDeliveryExperience/standardDeliveryVendor";
import TwoDayDeliveryVendor from "@/app/checkout/(squeeze)/review/twoDayDeliveryExperience/twoDayDeliveryVendor";
import { CheckoutOrder, CheckoutResponse } from "@/fetch/getCheckoutResponse";

export default function VendorSection({
  checkoutResponse,
  isConfirmationPage,
}: {
  checkoutResponse: CheckoutResponse | null;
  isConfirmationPage: boolean;
}) {
  const [twoDayDeliveryVendors, setTwoDayDeliveryVendors] = useState<CheckoutOrder[]>([]);
  const [standardDeliveryVendors, setStandardDeliveryVendors] = useState<CheckoutOrder[]>([]);

  useEffect(() => {
    if (checkoutResponse) {
      const twoDayDeliveryVendors = checkoutResponse?.vendorOrders?.filter((vendorOrder) =>
        vendorOrder?.products?.some((product) => product?.twoDayDeliverySw),
      );
      const standardDeliveryVendors = checkoutResponse?.vendorOrders?.filter(
        (vendorOrder) => !vendorOrder?.products?.some((product) => product?.twoDayDeliverySw),
      );

      setTwoDayDeliveryVendors(twoDayDeliveryVendors);
      setStandardDeliveryVendors(standardDeliveryVendors);
    }
  }, [checkoutResponse]);

  return (
    <>
      <div className="standardShippingVariation">
        {(checkoutResponse as CheckoutResponse).vendorOrders.map((vendorOrder, index) => (
          <CheckoutReviewVendorOrderSection
            key={index}
            shoppingCartVendorOrder={vendorOrder}
            isConfirmationPage={isConfirmationPage}
          />
        ))}
      </div>
      <div className="twoDayDeliveryVariation">
        <TwoDayDeliveryVendor vendors={twoDayDeliveryVendors} isConfirmationPage={isConfirmationPage} />
        <StandardDeliveryVendor vendors={standardDeliveryVendors} isConfirmationPage={isConfirmationPage} />
      </div>
    </>
  );
}
